const sentryUrl =
  'https://277b4676e9f448ab9508ec958cbb970c@o4504434079301632.ingest.sentry.io/4504434081660928'

const videoUrl =
  'https://storage.pardot.com/873531/1651055274Iu5NgSl3/video_5__2_.mp4'

const gusUrl = 'https://www.globaluniversitysystems.com/'

const privacyPolicyUrl =
  'https://www.globaluniversitysystems.com/privacy-policy'

const termsAndConditionsUrl =
  'https://www.globaluniversitysystems.com/terms-and-conditions'

const ourNetwork = 'https://www.globaluniversitysystems.com/our-network'

const salesforceChatbotScriptUrl =
  'https://iapro--preprod.sandbox.my.site.com/ESWAppHeroStaging1785145908130/assets/js/bootstrap.min.js'

export const FW_CHAT_BOT_URL = () => salesforceChatbotScriptUrl

export {
  sentryUrl,
  videoUrl,
  privacyPolicyUrl,
  gusUrl,
  termsAndConditionsUrl,
  ourNetwork,
}
